// CardCarousel.js
import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import "./CardCarousel.css";

/*
const cards = [
  { id: 1, title: "題組型（有標準答案）", color: "#f9c74f" },
  { id: 2, title: "題組型（無標準答案）", color: "#f9844a" },
  { id: 3, title: "圖文型（有標準答案）", color: "#90be6d" },
  { id: 4, title: "圖文型（無標準答案）", color: "#577590" },
];
*/

const CardCarousel = ({ cards, activeIndex=0, setActiveIndex }) => {

  const goLeft = () => setActiveIndex((prev) => Math.max(prev - 1, 0));
  const goRight = () => setActiveIndex((prev) => Math.min(prev + 1, cards.length - 1));

  const handlers = useSwipeable({
    onSwipedLeft: () => goRight(),
    onSwipedRight: () => goLeft(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true, // allow swipe with mouse for testing
  });

  const getTranslateX = (index) => {
    if (index === 0) return "calc(50% - 40vw)"; // first card offset
    if (index === cards.length - 1) return `calc(50% - ${(index * 63.5 + 42)}vw + 10vw)`; // adjust for last card
    return `calc(50% - ${index * 63.5 + 31}vw)`; // default
  };

  return (
    <div className="carousel-container">
      <div className="carousel-cards-wrapper" {...handlers}>
        <div
          className="carousel-cards-inner"
          style={{
            transform: `translateX(${getTranslateX(activeIndex)})`,
          }}
        >
          {cards.map((card, idx) => (
            <div
              key={card.id}
              className={`carousel-card ${`carousel-card-${idx+1}`} 
                ${idx === activeIndex ? "active" : ""}`
              }
              style={{ 
                border: `3px solid ${card.color}`,
                fontSize: "16px",
                color: "black"
              }}
              onClick={()=>{setActiveIndex((prev) => card.id-1)}}
            >
              <div style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                height: "30%",
                width: "90%"
              }}>
                <p className="mb-0">{card.title}</p>
                <p className="mb-0">{card.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="carousel-pagination-dots">
        {cards.map((_, idx) => (
          <span
            key={idx}
            className={`carousel-dot ${idx === activeIndex ? "active" : ""}`}
            onClick={() => setActiveIndex(idx)}
          />
        ))}
      </div>

      <div className="carousel-nav-buttons">
        <button onClick={goLeft} disabled={activeIndex === 0}>‹</button>
        <button onClick={goRight} disabled={activeIndex === cards.length - 1}>›</button>
      </div>
    </div>
  );
};

export default CardCarousel;
